import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION = {
	// "0":"ButtonSubmit0",
	signature2: 'CC006',
	signature1: 'CC005',
	dateYear: 'CC009',
	dateMonth: 'CC008',
	dateDay: 'CC007',
	checkbox: 'Check Box12',
	fourthBulletPointCheckbox: 'Text16',
	fourthBulletPoint2: 'Text10',
	fourthBulletPoint: 'Text9',
	secondBulletPoint2: 'Text8',
	secondBulletPoint: 'Text7',
	propertyAddress: 'Text6',
	mortgageNumber: 'Text5',
	mortgageApplicantName: 'CC003',
	vendorName: 'CC002',
	nameType: 'CC001',
};

export interface BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION {
	mortgageNumber: string;
	propertyAddress: string;

	nameType: string;
	vendorName: string;
	mortgageApplicantName: string;

	secondBulletPoint: string;
	secondBulletPoint2: string;

	fourthBulletPoint: string;
	fourthBulletPoint2: string;
	fourthBulletPointCheckbox: string;

	checkbox: string;

	dateDay: string;
	dateMonth: string;
	dateYear: string;

	signature1: string;
	signature2: string;
}
